var $76ba0d80630b02ae$exports = {};
$76ba0d80630b02ae$exports = {
    "clear": `Cancella`,
    "invalid": `(non valido)`,
    "loading": `Caricamento in corso...`,
    "noResults": `Nessun risultato`,
    "valid": `(valido)`
};


export {$76ba0d80630b02ae$exports as default};
//# sourceMappingURL=it-IT.mjs.map
